import { Box, Flex, Text, ThemeIcon } from '@mantine/core';

import type { StepStyles } from '../../hooks/useStepStyles';
import type { IStepItem } from '../../types';

interface IPropsStepperItem {
  step: IStepItem;
  stepStyles: StepStyles;
}

export default function StepperItem(props: IPropsStepperItem) {
  const { step, stepStyles } = props;
  const stepStyle = stepStyles[step.status];

  return (
    <Flex align="center" mx={16} gap="sm">
      <ThemeIcon
        variant="light"
        style={{
          border: `2px solid ${stepStyle.color}`,
          flexShrink: 0,
        }}
        color={stepStyle.color}
        radius="xl"
        size={stepStyle.iconSize}
      >
        {stepStyle.icon}
      </ThemeIcon>
      <Box style={{ flex: 1 }}>
        <Text fw={600} size={stepStyle.titleSize}>
          {step.title}
        </Text>
        <Text size="sm" c="dimmed">
          {step.description || ''}
        </Text>
      </Box>
    </Flex>
  );
}
